import React, { useEffect, useState } from 'react';

/**
 * Modal al cerrar gratificación: declara si ingresa o no a planilla de remuneraciones.
 */
const CerrarGratificacionConfirmModal = ({ open, subtitulo, submitting, onCancel, onConfirm }) => {
  const [entraraPlanilla, setEntrarPlanilla] = useState(null);

  useEffect(() => {
    if (open) setEntrarPlanilla(null);
  }, [open]);

  if (!open) return null;

  const opcionSeleccionada = entraraPlanilla === true || entraraPlanilla === false;

  return (
    <div className="fixed inset-0 z-[70] overflow-y-auto" aria-labelledby="cerrar-grat-modal-title" role="dialog" aria-modal="true">
      <div className="flex min-h-full items-center justify-center p-4">
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-60 transition-opacity"
          onClick={submitting ? undefined : onCancel}
          aria-hidden="true"
        />
        <div className="relative bg-white rounded-2xl shadow-2xl max-w-lg w-full border border-gray-200 overflow-hidden">
          <div className="bg-gradient-to-r from-green-700 to-emerald-600 px-5 py-4">
            <h3 id="cerrar-grat-modal-title" className="text-lg font-semibold text-white">
              Cerrar gratificación
            </h3>
            {subtitulo ? (
              <p className="text-sm text-green-100 mt-1">{subtitulo}</p>
            ) : null}
          </div>

          <div className="p-5 space-y-4">
            <p className="text-sm text-gray-700">
              Al cerrar podrá <strong className="text-gray-900">reabrir</strong> si necesita cambios; mientras permanezca
              cerrada no podrá editar montos de empleados sin reabrir.
            </p>

            <div>
              <p className="text-sm font-semibold text-gray-900 mb-3">¿Incluir en planilla?</p>
              <p className="text-xs text-gray-600 mb-3">
                Indique si estos montos de gratificación se incluirán o reflejarán en la planilla de haberes.
              </p>
              <div className="grid gap-3 sm:grid-cols-2" role="radiogroup" aria-label="Incluir en planilla">
                <button
                  type="button"
                  disabled={submitting}
                  onClick={() => setEntrarPlanilla(true)}
                  className={`text-left rounded-xl border-2 px-4 py-3 transition-all duration-150 ${
                    entraraPlanilla === true
                      ? 'border-emerald-500 bg-emerald-50 ring-2 ring-emerald-400 shadow-sm'
                      : 'border-gray-200 bg-gray-50 hover:border-emerald-200 hover:bg-white'
                  } disabled:opacity-50`}
                >
                  <span className="flex items-start gap-2">
                    <span
                      className={`mt-0.5 inline-flex h-4 w-4 shrink-0 rounded-full border-2 ${
                        entraraPlanilla === true ? 'border-emerald-600 bg-emerald-600' : 'border-gray-300 bg-white'
                      }`}
                      aria-hidden
                    >
                      {entraraPlanilla === true ? (
                        <span className="m-auto block h-1.5 w-1.5 rounded-full bg-white" />
                      ) : null}
                    </span>
                    <span>
                      <span className="block text-sm font-semibold text-emerald-900">Sí, incluir en planilla</span>
                      <span className="block text-xs text-gray-600 mt-0.5">
                        Los montos se registrarán o cargarán en planilla de remuneraciones.
                      </span>
                    </span>
                  </span>
                </button>
                <button
                  type="button"
                  disabled={submitting}
                  onClick={() => setEntrarPlanilla(false)}
                  className={`text-left rounded-xl border-2 px-4 py-3 transition-all duration-150 ${
                    entraraPlanilla === false
                      ? 'border-gray-500 bg-gray-100 ring-2 ring-gray-400 shadow-sm'
                      : 'border-gray-200 bg-gray-50 hover:border-gray-300 hover:bg-white'
                  } disabled:opacity-50`}
                >
                  <span className="flex items-start gap-2">
                    <span
                      className={`mt-0.5 inline-flex h-4 w-4 shrink-0 rounded-full border-2 ${
                        entraraPlanilla === false ? 'border-gray-700 bg-gray-700' : 'border-gray-300 bg-white'
                      }`}
                      aria-hidden
                    >
                      {entraraPlanilla === false ? <span className="m-auto block h-1.5 w-1.5 rounded-full bg-white" /> : null}
                    </span>
                    <span>
                      <span className="block text-sm font-semibold text-gray-900">No incluir en planilla</span>
                      <span className="block text-xs text-gray-600 mt-0.5">
                        Solo cerrar el cálculo; sin declarar ingreso a planilla desde este cierre.
                      </span>
                    </span>
                  </span>
                </button>
              </div>
            </div>
          </div>

          <div className="px-5 py-4 bg-gray-50 border-t border-gray-200 flex flex-col-reverse sm:flex-row sm:justify-end gap-2">
            <button
              type="button"
              disabled={submitting}
              onClick={onCancel}
              className="w-full sm:w-auto px-4 py-2.5 text-sm font-medium rounded-lg bg-white border border-gray-300 text-gray-700 hover:bg-gray-100 disabled:opacity-50"
            >
              Cancelar
            </button>
            <button
              type="button"
              disabled={submitting || !opcionSeleccionada}
              onClick={() => onConfirm(entraraPlanilla)}
              className="w-full sm:w-auto px-4 py-2.5 text-sm font-semibold rounded-lg bg-green-600 text-white hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {submitting ? 'Cerrando…' : 'Confirmar y cerrar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CerrarGratificacionConfirmModal;
